import { CALL_API } from 'middleware/api';
export const getSharedPlans = () => ({
    [CALL_API]: {
        endpoint: `/extra-members`,
        method: 'GET',
        headers: {
            Accept: 'application/json',
        },
        types: [
            'GET_SHARED_PLANS_REQUEST',
            'GET_SHARED_PLANS_SUCCESS',
            'GET_SHARED_PLANS_FAILURE',
        ],
    },
});
export const getSharedPricePreview = (body) => ({
    [CALL_API]: {
        endpoint: `/stripe/subscription/seats/preview`,
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
        types: [
            'GET_SHARED_PLANS_PREVIEW_REQUEST',
            'GET_SHARED_PLANS_PREVIEW_SUCCESS',
            'GET_SHARED_PLANS_PREVIEW_FAILURE',
        ],
    },
});
export const purchaseExtraMemberSlots = (body, isAutoRenewingOrCancelling) => ({
    [CALL_API]: {
        endpoint: `/stripe/subscription/seats`,
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
        extra: {
            isAutoRenewingOrCancelling,
        },
        types: [
            'PURCHASE_EXTRA_MEMBER_SLOTS_REQUEST',
            'PURCHASE_EXTRA_MEMBER_SLOTS_SUCCESS',
            'PURCHASE_EXTRA_MEMBER_SLOTS_FAILURE',
        ],
    },
});
export const cancelExtraMemberSlot = (body) => ({
    [CALL_API]: {
        endpoint: `/stripe/subscription/seats/cancel`,
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
        types: [
            'CANCEL_EXTRA_MEMBER_SLOT_REQUEST',
            'CANCEL_EXTRA_MEMBER_SLOT_SUCCESS',
            'CANCEL_EXTRA_MEMBER_SLOT_FAILURE',
        ],
    },
});
export const enableAutoRenewForExtraMember = (body) => ({
    [CALL_API]: {
        endpoint: `/stripe/subscription/seats/renew`,
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
        types: [
            'ENABLE_AUTO_RENEW_FOR_EXTRA_MEMBER_REQUEST',
            'ENABLE_AUTO_RENEW_FOR_EXTRA_MEMBER_SUCCESS',
            'ENABLE_AUTO_RENEW_FOR_EXTRA_MEMBER_FAILURE',
        ],
    },
});
export const removeExtraMember = (userId, isLeaveFlow) => ({
    [CALL_API]: {
        endpoint: `/extra-members/${userId}/remove`,
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        extra: {
            isLeaveFlow,
        },
        types: [
            'REMOVE_EXTRA_MEMBER_REQUEST',
            'REMOVE_EXTRA_MEMBER_SUCCESS',
            'REMOVE_EXTRA_MEMBER_FAILURE',
        ],
    },
});
export const inviteMemberToExtraMembers = (body) => ({
    [CALL_API]: {
        endpoint: `/extra-members/invites`,
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        extra: {
            handles: body.handles,
        },
        body: JSON.stringify(body),
        types: [
            'INVITE_TO_EXTRA_MEMBER_SLOT_REQUEST',
            'INVITE_TO_EXTRA_MEMBER_SLOT_SUCCESS',
            'INVITE_TO_EXTRA_MEMBER_SLOT_FAILURE',
        ],
    },
});
export const getExtraMemberInviteRequests = () => ({
    [CALL_API]: {
        endpoint: `/extra-members/invites`,
        method: 'GET',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        types: [
            'GET_EXTRA_MEMBER_INVITE_REQUESTS_REQUEST',
            'GET_EXTRA_MEMBER_INVITE_REQUESTS_SUCCESS',
            'GET_EXTRA_MEMBER_INVITE_REQUESTS_FAILURE',
        ],
    },
});
export const acceptExtraMemberInvite = (id) => ({
    [CALL_API]: {
        endpoint: `/extra-members/invites/${id}/accept`,
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        types: [
            'ACCEPT_EXTRA_MEMBER_INVITE_REQUEST',
            'ACCEPT_EXTRA_MEMBER_INVITE_SUCCESS',
            'ACCEPT_EXTRA_MEMBER_INVITE_FAILURE',
        ],
    },
});
export const acceptExtraMemberInviteFromLink = (uuid) => ({
    [CALL_API]: {
        endpoint: `/extra-members/invites/link/${uuid}/accept`,
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        types: [
            'ACCEPT_EXTRA_MEMBER_INVITE_FROM_LINK_REQUEST',
            'ACCEPT_EXTRA_MEMBER_INVITE_FROM_LINK_SUCCESS',
            'ACCEPT_EXTRA_MEMBER_INVITE_FROM_LINK_FAILURE',
        ],
    },
});
export const rejectExtraMemberInvite = (id) => ({
    [CALL_API]: {
        endpoint: `/extra-members/invites/${id}/reject`,
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        types: [
            'REJECT_EXTRA_MEMBER_INVITE_REQUEST',
            'REJECT_EXTRA_MEMBER_INVITE_SUCCESS',
            'REJECT_EXTRA_MEMBER_INVITE_FAILURE',
        ],
    },
});
export const rejectExtraMemberInviteFromLink = (uuid) => ({
    [CALL_API]: {
        endpoint: `/extra-members/invites/link/${uuid}/reject`,
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        types: [
            'REJECT_EXTRA_MEMBER_INVITE_FROM_LINK_REQUEST',
            'REJECT_EXTRA_MEMBER_INVITE_FROM_LINK_SUCCESS',
            'REJECT_EXTRA_MEMBER_INVITE_FROM_LINK_FAILURE',
        ],
    },
});
export const clearExtraMemberInvites = () => ({
    type: 'CLEAR_EXTRA_MEMBER_INVITES',
});
export const getExtraMemberInviteLink = () => ({
    [CALL_API]: {
        endpoint: `/extra-members/invites/link`,
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        types: [
            'GET_EXTRA_MEMBER_INVITE_LINK_REQUEST',
            'GET_EXTRA_MEMBER_INVITE_LINK_SUCCESS',
            'GET_EXTRA_MEMBER_INVITE_LINK_FAILURE',
        ],
    },
});
export const getExtraMemberInviteLinkInfo = (uuid) => ({
    [CALL_API]: {
        endpoint: `/extra-members/invites/link/${uuid}`,
        method: 'GET',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        extra: {
            uuid,
        },
        types: [
            'GET_EXTRA_MEMBER_INVITE_LINK_INFO_REQUEST',
            'GET_EXTRA_MEMBER_INVITE_LINK_INFO_SUCCESS',
            'GET_EXTRA_MEMBER_INVITE_LINK_INFO_FAILURE',
        ],
    },
});
export const getExtraMemberCancelledInvites = () => ({
    [CALL_API]: {
        endpoint: `/extra-members/invites/rejected`,
        method: 'GET',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        types: [
            'GET_EXTRA_MEMBER_CANCELLED_INVITES_REQUEST',
            'GET_EXTRA_MEMBER_CANCELLED_INVITES_SUCCESS',
            'GET_EXTRA_MEMBER_CANCELLED_INVITES_FAILURE',
        ],
    },
});
export const dismissExtraMemberCancelledInvite = (id) => ({
    [CALL_API]: {
        endpoint: `/extra-members/invites/${id}/dismiss`,
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        muteAlert: true,
        types: [
            'DISMISS_EXTRA_MEMBER_CANCELLED_INVITE_REQUEST',
            'DISMISS_EXTRA_MEMBER_CANCELLED_INVITE_SUCCESS',
            'DISMISS_EXTRA_MEMBER_CANCELLED_INVITE_FAILURE',
        ],
    },
});
export const remindOwnerToRenewPlan = () => ({
    [CALL_API]: {
        endpoint: `/extra-members/reminder`,
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        types: [
            'REMIND_OWNER_TO_RENEW_PLAN_REQUEST',
            'REMIND_OWNER_TO_RENEW_PLAN_SUCCESS',
            'REMIND_OWNER_TO_RENEW_PLAN_FAILURE',
        ],
    },
});
export const removeExtraMemberCancelledInvite = (id) => ({
    id,
    type: 'REMOVE_EXTRA_MEMBER_CANCELLED_INVITE',
});
export const setSuggestFrom = (suggestFrom) => ({
    type: 'SET_SUGGEST_FROM',
    suggestFrom,
});
export const clearSuggestFrom = () => ({
    type: 'CLEAR_SUGGEST_FROM',
});
